var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconViewList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.25H16.75V5.75H3.25V4.25ZM3.25 9.25H16.75V10.75H3.25V9.25ZM3.25 14.25H16.75V15.75H3.25V14.25Z",
    fill: "#0A0D14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewList);
export default __webpack_public_path__ + "static/media/icon-view-list.e4f943564b943f12504c0c3faea36c05.svg";
export { ForwardRef as ReactComponent };